import * as h2Api from '../h2Api'
import { browserHistory } from '../Routes'

export const LOAD_INITIAL_ACTIVITY = 'LOAD_INITIAL_ACTIVITY'
export const LOAD_REQUEST_INFO = 'LOAD_REQUEST_INFO'
export const APPROVE_REQUEST = 'APPROVE_REQUEST'
export const REJECT_REQUEST = 'REJECT_REQUEST'
export const PARENT_CLICK_TAB = 'PARENT_CLICK_TAB'
export const PARENT_TOGGLE_FILTER = 'PARENT_TOGGLE_FILTER'
export const PARENT_TOGGLE_CHILD = 'PARENT_TOGGLE_CHILD'
export const ASSOCIATION_KEY = 'ACCOUNT_ASSOCIATION_KEY'
export const CLEAR_ASSOCIATION_KEY = 'CLEAR_ASSOCIATION_KEY'

// -------------------- Action Creators

export const clickTab = tabId => dispatch => dispatch({ type: PARENT_CLICK_TAB, tabId })

export const loadFeedData = () => dispatch => {
  return dispatch(h2Api.get('/management/parent/feed')({ type: LOAD_INITIAL_ACTIVITY }))
}

export const loadInitialChildData = callback => dispatch =>
  dispatch(
    h2Api.get('/management/managees/list/parent')({ type: LOAD_INITIAL_ACTIVITY })
  ).then(() => callback())

export const toggleFilter = () => dispatch => {
  dispatch({ type: PARENT_TOGGLE_FILTER })
}

export const toggleActiveUsers = (userId, active) => dispatch => {
  dispatch({ type: PARENT_TOGGLE_CHILD, userId, active })
}

export const checkRequestExists = code => dispatch => {
  return dispatch(
    h2Api.get(`/management/request/bycode/${code}`)({ type: LOAD_REQUEST_INFO })
  )
}

export const acceptRequest = code => dispatch => {
  if (dynamicValues.userProfile) {
    return dispatch(
      h2Api.get(`/management/request/bycode/${code}/approve`)({ type: APPROVE_REQUEST })
    )
  }

  return Promise.resolve(dispatch({ type: ASSOCIATION_KEY, key: code })).then(() =>
    browserHistory.push('/signin')
  )
}

export const rejectRequest = code => dispatch => {
  return dispatch(
    h2Api.get(`/management/request/bycode/${code}/reject`)({ type: REJECT_REQUEST })
  )
}
